import React from 'react';
import { Link } from 'react-router-dom';

import logoLockup from '../../assets/img/logo-lockup.svg';
import whatThe from '../../assets/icon/what-the.svg';

import './coming_soon.scss';

// Inline SVGs for the store badges — placeholder visuals while the apps
// are still in internal testing. Swap to the official "Download on the
// App Store" / "Get it on Google Play" badges (with working store URLs)
// once both apps go public.

const AppleIcon = () => (
	<svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor" aria-hidden="true">
		<path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.53 4.08zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
	</svg>
);

const PlayIcon = () => (
	<svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor" aria-hidden="true">
		<path d="M22.018 13.298l-3.919 2.218-3.515-3.493 3.543-3.521 3.891 2.202a1.49 1.49 0 0 1 0 2.594zM1.337.924a1.486 1.486 0 0 0-.337.94v20.272c0 .354.124.682.337.94l11.643-11.076L1.337.924zm12.71 10.131l2.65-2.522L4.794.249a1.485 1.485 0 0 0-1.565-.117l10.818 10.923zm-10.818 12.794a1.485 1.485 0 0 0 1.565-.117l11.953-8.169-2.674-2.658L3.229 23.849z" />
	</svg>
);

const StoreBadge = ({ icon: Icon, label, sub }) => (
	<div className="coming-soon__badge" role="presentation">
		<span className="coming-soon__badge-icon"><Icon /></span>
		<span className="coming-soon__badge-text">
			<span className="coming-soon__badge-sub">{sub}</span>
			<span className="coming-soon__badge-label">{label}</span>
		</span>
	</div>
);

const ComingSoon = () => (
	<div className="coming-soon">
		<main className="coming-soon__main">
			<img src={whatThe} alt="" aria-hidden="true" className="coming-soon__what-the" />
			<img src={logoLockup} alt="Italian Naturally" className="coming-soon__logo" />
			<p className="coming-soon__tagline">
				Learn Italian using practical dialogues with a focus on listening and speaking, similar to immersion, but faster!
			</p>
			<div className="coming-soon__stripe"><i /><i /><i /></div>
			<p className="coming-soon__status">
				Coming soon to the App Store and Google Play.
			</p>
			<div className="coming-soon__badges">
				<StoreBadge icon={AppleIcon} sub="Coming soon to" label="App Store" />
				<StoreBadge icon={PlayIcon} sub="Coming soon to" label="Google Play" />
			</div>
		</main>
		<footer className="coming-soon__footer">
			<Link to="/privacy">Privacy</Link>
			<span aria-hidden="true">·</span>
			<Link to="/terms">Terms</Link>
		</footer>
	</div>
);

export default ComingSoon;
